module.exports = __webpack_public_path__ + "img/AI (5).052eedc4.png";